import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import { BackArrow } from 'components/BackArrow';
import React, { FunctionComponent, useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { dietTypeFormSubmit } from 'redux/Signup';
import { DietTypes } from 'redux/User';

interface IProps {
  goBackOneStep: () => void;
  goForwardOneStep: () => void;
}

export const DietTypeForm: FunctionComponent<IProps> = ({ goBackOneStep, goForwardOneStep }) => {
  const { register, handleSubmit } = useForm();
  const dispatch = useDispatch();
  const onSubmit = useCallback(
    async data => {
      await dispatch(dietTypeFormSubmit(data));
      goForwardOneStep();
    },
    [dispatch, goForwardOneStep],
  );
  const navigate = useNavigate();

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box
        style={{
          display: 'flex',
          height: '90vh',
          justifyContent: 'space-between',
          flexDirection: 'column',
        }}
      >
        <Box>
          <Box
            style={{ display: 'flex', justifyContent: 'start', flexDirection: 'row' }}
            onClick={goBackOneStep}
          >
            <BackArrow />
          </Box>
          <Box style={{ paddingTop: '5vh' }}>
            <FormattedMessage id="type-of-diet.title">
              {(text: string) => (
                <Typography
                  align="center"
                  fontSize="22px"
                  fontFamily="Poppins Medium"
                  style={{ marginBottom: '2vh' }}
                >
                  {text}
                </Typography>
              )}
            </FormattedMessage>
          </Box>
          <Box style={{ margin: '0 10vw' }}>
            <FormControl component="fieldset">
              <RadioGroup
                aria-label="dietType"
                defaultValue={DietTypes.ENTERAL}
                name="radio-buttons-group"
              >
                <FormattedMessage id="type-of-diet.enteral">
                  {(text: string) => (
                    <FormControlLabel
                      value={DietTypes.ENTERAL}
                      control={<Radio />}
                      label={text}
                      {...register('dietType')}
                    />
                  )}
                </FormattedMessage>
                <FormattedMessage id="type-of-diet.oral">
                  {(text: string) => (
                    <FormControlLabel
                      value={DietTypes.ORAL}
                      control={<Radio />}
                      label={text}
                      {...register('dietType')}
                    />
                  )}
                </FormattedMessage>
              </RadioGroup>
            </FormControl>
          </Box>
        </Box>
        <Box>
          <FormattedMessage id="type-of-diet.back-to-home">
            {(text: string) => (
              <Typography
                align="center"
                style={{
                  fontFamily: 'Poppins Regular',
                  textDecoration: 'underline',
                  marginBottom: '2vh',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  navigate('/');
                }}
              >
                {text}
              </Typography>
            )}
          </FormattedMessage>

          <FormattedMessage id="type-of-diet.next">
            {(text: string) => (
              <Button
                type="submit"
                variant="contained"
                color="primary"
                style={{ height: '45px', width: '100%' }}
              >
                {text}
              </Button>
            )}
          </FormattedMessage>
        </Box>
      </Box>
    </form>
  );
};
